import { useDialog } from '@wheely/ui-kit';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { getIsAppInitialized } from '@/app/store/selectors';
import { getPartner } from '@/modules/partner/store/selectors';
import { usePrevious } from '@/shared/hooks/usePrevious';

import s from './styles.module.css';
import { CongratsView } from './view';

const useCongratsDialog = () => {
  const { openDialog } = useDialog();
  const intl = useIntl();

  const partner = useSelector(getPartner);
  const isAppInitialized = useSelector(getIsAppInitialized);

  const prevIsOnboardingCompleted = usePrevious(partner.onboarding.isCompleted);

  useEffect(() => {
    if (!isAppInitialized) {
      return;
    }

    if (prevIsOnboardingCompleted === undefined) {
      return;
    }

    if (prevIsOnboardingCompleted === partner.onboarding.isCompleted) {
      return;
    }

    openDialog(({ onClose }) => <CongratsView onContinueClick={onClose} />, {
      title: intl.formatMessage({
        defaultMessage: 'Congratulations',
        id: '1VMq+P',
        description: 'Dialog title',
      }),
      className: s.dialog,
      bodyClassName: s.dialogBody,
      titleClassName: s.dialogTitle,
    });
  }, [partner, isAppInitialized, intl, openDialog, prevIsOnboardingCompleted]);
};

export { useCongratsDialog };
